import React, { useState, useEffect, useContext } from 'react'
import { Form, Modal,Toast } from 'antd-mobile';
import { ExclamationCircleFill } from 'antd-mobile-icons';
import dayjs from 'dayjs'
import { submitWithFormData } from "api/api";
import { base1 } from 'api/config.js';
import { postNameConstant } from 'utils/constant/postName';
import { UserContext } from 'utils/getContext'
import { getAreaObj, getUserObj } from 'utils/getData'
import { judgeSex, userInfoHide, idCardHide } from "utils/ruleType";
import { affirmEmployPage1 } from 'data/affirmEmployFormBak';
import { GetFormType } from "./GetFormType";
import { FromSteps } from "./FromSteps";
import '../../../static/css/tip.css'

const { PROVINCE, CITY, COUNTRY, VILLAGE, TOWN } = postNameConstant

/** 就业困难人员认定 */
export function AffirmEmployDev() {
  const myContext = useContext(UserContext)
  const { userInfo } = myContext
  const { name, sex, idNum, birthday, USER_MOBILE } = userInfo ? userInfo : {}
  const [form] = Form.useForm();
  const [postData, setPostData] = useState({})
  const [content, setContent] = useState({});
  const [stepNum, setStepNum] = useState(1)
  const [areaContent, setAreaContent] = useState([])
  const [formId, setFormId] = useState('');
  const [files, setFiles] = useState([]);
  const [household, setHousehold] = useState();
  const [applicantPage, setApplicantPage] = useState();

  const title = ['申报信息', '提交申请']
  const msgTitle = '就业困难人员认定'
  const pageData = [affirmEmployPage1]
  /** 对默认返回的参数进行处理后显示到页面上 */
  useEffect(() => {
    if (userInfo) {
      form.setFieldsValue({
        username: idCardHide(name, 1, name.length - 1) || '',
        identification: userInfoHide(userInfo) || '',
        gender: judgeSex(sex),
        age: new Date().getFullYear() - new Date(birthday).getFullYear() || null,
        mobilePhone: USER_MOBILE || '',
      });
    }
  }, [sex, name, form, userInfo, idNum, birthday, USER_MOBILE]);


  /** 获取表单ID */
  useEffect(() => {
    const date = dayjs().format('YYYYMMDDHHmmss');
    setFormId(date + guid());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** 初始化数据 */
  useEffect(() => {
    // getAreaObj('', areaContent, setAreaContent, true)
    getAreaObj('', areaContent, setAreaContent)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** 获取表单ID */
  function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // eslint-disable-next-line no-bitwise
      const r = Math.random() * 16 | 0;
      // eslint-disable-next-line no-bitwise
      // eslint-disable-next-line no-mixed-operators
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  /** 更新提交表单接口参数数据 */
  function setFormInfo(name, value) {
    const newPostData = { ...postData }
    newPostData[name] = value
    setPostData(newPostData)
  }

  /** 获取表单数据 */
  function getWord(str) {
    if (form.getFieldValue(str)) {
      return form.getFieldValue(str);
    }
    return '';
  }

  /** 处理地区数据 */
  function handleAreaData(value, type) {
    const data = getWord(value)
    switch (type) {
      case PROVINCE:
        return data[0] ?? ''
      case CITY:
        return data[1] ?? ''
      case COUNTRY:
        return data[2] ?? ''
      case VILLAGE:
        return data[3] ?? ''
      case TOWN:
        return data[4] ?? ''
      default:
        return ''
    }
  }
  //提交表单
  async function handleSubmitFormClick(setLoading) {

    if (stepNum === title.length - 1) {
      setLoading(true);

      // 对应数据库表单名称 T_PSM_EmpHard
      try {
        const formData = await form.validateFields();
        const postData = {
          name: name, // 姓名
          idNum: idNum, // 身份证号码
          sex: sex, // 性别
          age: formData.age, // 年龄
          mobile: formData.mobilePhone || USER_MOBILE,
          household: formData.registration, // 户口性质
          affirmation: formData.affirmation, // 就业困难人员认定地
          residentProvince: handleAreaData('permanent', PROVINCE), // 户籍省
          residentCity: handleAreaData('permanent', CITY), // 户籍市
          residentCountry: handleAreaData('permanent', COUNTRY), // 户籍区
          residentVillage: handleAreaData('permanent', VILLAGE), // 户籍镇
          residentTown: handleAreaData('permanent', TOWN), // 户籍村
          residentDetailedAddress: getWord('reDetail'), // 户籍详细地址
          permanentProvince: handleAreaData('address', PROVINCE), // 常住省
          permanentCity: handleAreaData('address', CITY), // 常住市
          permanentCountry: handleAreaData('address', COUNTRY), // 常住区
          permanentVillage: handleAreaData('address', VILLAGE), // 常住镇
          permanentTown: handleAreaData('address', TOWN), // 常住村
          permanentDetailedAddress: getWord('detail'), // 常住详细地址
          peopleType: formData.personType, // 人员类别认定类型
          formId, // 上传表单ID
          type: 63,
          FHousehold: household,
          FApplicantPage: applicantPage,
          FOtherDocuments: files, 
        };
        //表单提交方式
        const postData2 = new FormData();
        for (const key in postData) {
          if (key) {
            if (postData[key] instanceof Array) {
              postData[key].forEach((item) => {
                postData2.append(key, item)
              })
            } else {
              postData2.append(key, postData[key]);
            }
          }
        }

        const { data, success } = await submitWithFormData({ name: name, idNum: idNum, regiperm: postData?.household[0] }, `${base1}hrss/employmentHard/hardConfirm`);

        if (success && data.status === '1') {
          const res = await submitWithFormData(postData2, `${base1}hrss/employmentHardAppendFiles`)
          // const res = await submitWithFormData(postData2, `${base1}hrss/employmentHard`)
          if (res?.code === 200) {
            setStepNum(stepNum + 1)
          }
        } else {
          Modal.alert({
            header: (
              <ExclamationCircleFill
                style={{
                  fontSize: 50,
                  color: 'var(--adm-color-warning)',
                }}
              />
            ),
            title: '注意',
            content: (
              <>
                {data.details?.map((item, index) => {
                  return <div className="modal-item">
                    <span>({index + 1})&nbsp;&nbsp;{item.condition}</span>
                    <span className={`${item.result === '1' ? 'passItem' : 'failItem'}`}>
                      {item.result === '1' ? '已通过' : '未通过'}
                    </span>
                  </div>
                })}
              </>
            ),
          })
        }
      } catch (e) {
        Toast.show({
          icon: 'fail',
          content: '提交失败，请检查内容并重试',
        })
      } finally {
        setLoading(false);
      }
    }
  }
  // 初始化表单渲染模板
  const getType = (arr, index) =>
    <GetFormType
      key={index}
      item={arr}
      form={form}
      setFormInfo={setFormInfo}
      content={content}
      setContent={setContent}
      getUserObj={getUserObj}
      //cityContent={cityContent}
      setHousehold={setHousehold}
      setApplicantPage={setApplicantPage}
      areaContent={areaContent}
      setAreaContent={setAreaContent}
      formId={formId}
      setFiles={setFiles}
      //getCityTreeObj={getCityTreeObj}
      getAreaObj={getAreaObj}
      msgTitle={msgTitle}
    />

  return (
    <FromSteps
      stepNum={stepNum}
      title={title}
      getType={getType}
      setStepNum={setStepNum}
      form={form}
      pageData={pageData}
      handleSubmitFormClick={handleSubmitFormClick}
    />
  )
}